import { render, staticRenderFns } from "./LabelCraft.vue?vue&type=template&id=7908a7de&scoped=true"
import script from "./LabelCraft.vue?vue&type=script&lang=js"
export * from "./LabelCraft.vue?vue&type=script&lang=js"
import style0 from "./LabelCraft.vue?vue&type=style&index=0&id=7908a7de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908a7de",
  null
  
)

export default component.exports